<template>
    <div>
        <v-chip outlined>
            {{ environments[item[header.value]] || 'Não identificado' }} 
            <v-icon right small color="grey">
                mdi-server
            </v-icon>
        </v-chip>
    </div>
</template>

<script setup>

import { defineProps } from 'vue'

const environments = {
    'local': 'Development',
    'staging': 'Staging',
    'production': 'Production',
}

const props = defineProps({
    header: { type: Object, required: true },
    item: { type: Object, required: true },
})

</script>